import styles from "./Chat.module.css";
import Baloon from "./Baloon/Baloon";
import Input from "./Input/Input";
import { useState } from "react";


export default function Chat(props){
  let messages = props.messages;
  const [msgHistory, setMsgHistory] = useState([{"msg": messages["start"].mensaje, "voice": messages["start"].voice, "align": "left", "file": messages["start"].file}]);
  const [currentMsgKey, setCurrentMsgKey] = useState("start");
  const [opciones, setOpciones] = useState(messages[currentMsgKey].opciones);

  function addMessage(msg, next){
      let answer= {
        "msg": msg,
        "voice": false,
        "align": "right",
        "file": ""
      }
      setOpciones((oldOpciones)=>[]);
      setMsgHistory((oldHistory) => [answer, ...oldHistory]);
      setTimeout(function(){
        let newMsg = {"msg": messages[next].mensaje, "voice": messages[next].voice, "align": "left", "file": messages[next].file};
        setMsgHistory((oldHistory) => [newMsg, ...oldHistory]);
        setCurrentMsgKey(next);
        //console.log(messages[currentMsgKey].opciones);
        setOpciones((oldOpciones) => messages[next].opciones)

      }, 1000)

      /* autoplay al enviar */
      if(props.audio) props.audio.pause();
      props.audio = new Audio(process.env.PUBLIC_URL + '/audios/' + messages[next].file);
      props.audio.play();

  }

  let classes = styles.chat;
  if (props.open)
    classes += " " + styles.open


  return(<div className={classes}>
    <div className={styles.container}>
      {msgHistory.map(function(item, i){

        return(<Baloon align={item.align} text={item.msg} voice={item.voice} file={item.file}/>)
      }) }

    </div>
<Input options={opciones} addMessage={addMessage}/>

  </div>)
}
